var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermarkLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1086",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_5640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-80.5547 1363.49H232.495L519.237 1076.84L806.16 1364H1121.38L518.73 761.345L-80.5547 1363.49Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.38 -277.493H808.331L521.589 9.15634L234.702 -278H-80.5547L522.096 324.655L1121.38 -277.493Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.49 988.63V827.152L1045.93 540.322L1333 253.346V94.4746L1175.95 95.1623L730.531 540.828L1175.84 984.286L1332.49 988.63Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-308.493 94.4746V255.989L-21.9323 542.819L-309 829.795V988.63L-151.914 987.978L293.469 542.312L-151.842 98.8545L-308.493 94.4746Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_5640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1642,
    height: 1642,
    fill: "white",
    transform: "translate(-309 -278)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkLaptop);
export default __webpack_public_path__ + "static/media/watermark-laptop.2a134bb9519f04866ca3dadb09876d5a.svg";
export { ForwardRef as ReactComponent };